var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Index"}},[_c('Hero',[_c('h1',[_vm._v(_vm._s(_vm.$t('title')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }